import { render, staticRenderFns } from "./hotQuestion-list.vue?vue&type=template&id=4e051f16&scoped=true&"
import script from "./hotQuestion-list.vue?vue&type=script&lang=js&"
export * from "./hotQuestion-list.vue?vue&type=script&lang=js&"
import style0 from "./hotQuestion-list.vue?vue&type=style&index=0&id=4e051f16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e051f16",
  null
  
)

export default component.exports